if (!customElements.get('freebie-signup')) {
  customElements.define(
    'freebie-signup',
    class FreebieSignup extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-freebie-result]')?.focus();
        this.form = this.querySelector('form');
        this.email = this.querySelector('input[type="email"]');
        this.consent = this.querySelector('[data-freebie-consent]');
        this.button = this.querySelector('[data-freebie-submit]');
        this.status = this.querySelector('[data-freebie-status]');
        this.spinner = this.querySelector('.loading__spinner');
        if (!this.form || !this.email || !this.consent || !this.button) return;

        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.email.addEventListener('input', () => this.syncButton(), options);
        this.email.addEventListener('change', () => this.syncButton(), options);
        this.consent.addEventListener('change', () => this.syncButton(), options);
        this.form.addEventListener('submit', (event) => this.onSubmit(event), options);
        window.addEventListener('pageshow', () => this.reset(), options);
        this.reset();
      }

      disconnectedCallback() {
        this.listeners?.abort();
      }

      syncButton() {
        this.button.disabled = this.submitting || !this.consent.checked || !this.email.validity.valid;
      }

      reset() {
        this.submitting = false;
        this.form.removeAttribute('aria-busy');
        this.button.classList.remove('loading');
        this.spinner.classList.add('hidden');
        this.status.textContent = '';
        this.syncButton();
      }

      onSubmit(event) {
        if (this.submitting) {
          event.preventDefault();
          return;
        }
        if (!this.consent.checked || !this.form.reportValidity()) {
          event.preventDefault();
          this.form.reportValidity();
          return;
        }

        this.submitting = true;
        // Let Shopify's spam protection and other submit handlers cancel first.
        // A cancelled submission must leave the form available for another attempt.
        queueMicrotask(() => {
          if (event.defaultPrevented) {
            this.reset();
            return;
          }
          this.form.setAttribute('aria-busy', 'true');
          this.button.classList.add('loading');
          this.spinner.classList.remove('hidden');
          this.status.textContent = this.status.dataset.submittingMessage;
          this.syncButton();
        });
      }
    }
  );
}
